import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import {NavbarComponent} from '../../components/navbar/navbar.component';

import {MatTableDataSource, MatTableModule} from '@angular/material/table';
import {MatPaginator, MatPaginatorIntl, MatPaginatorModule} from '@angular/material/paginator';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import {AffairesService, AffairQueryParams} from '../../services/affaires.service';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {FormsModule} from '@angular/forms';
import {NgForOf, NgIf} from '@angular/common';
import {MatProgressSpinner} from '@angular/material/progress-spinner';
import {MatSnackBar} from '@angular/material/snack-bar';
import {ActivatedRoute, Router} from '@angular/router';
import {HeadersTool} from '../../tools/headers';
import {saveAs} from 'file-saver';
import {DocumentsService} from "../../services/documents.service";
import {MatIcon} from "@angular/material/icon";
import {getFrenchPaginatorIntl} from "../../translators/mat-paginator-intl-fr";

export interface AffairProduct {
  id: number;
  price: number;
  quantity: number;
  dateReceiptFormatted: string;
  dateReceipt: string;
  dateRealisation: string;
  dateRealisationFormatted: string;
  product: {
    id: number;
    name: string;
    icon: string;
    color: string;
  };
  productStatus: {
    id: number;
    name: string;
    labelClass: string;
    color: string;
  };
  technicians: Technician[];
}

export interface Technician {
  initials: string;
  lastname: string;
  firstname: string;
  email: string;
  color: string;
  fullName: string;
}

export interface Affair {
  id: number;
  mlRef: string;
  customerRef: string | null;
  folderNumber: string | null;
  finalCustomerLastname: string;
  finalCustomerFirstname: string | null;
  finalCustomerLastnameSecondary: string | null;
  finalCustomerFirstnameSecondary: string | null;
  workSiteStreetNumber: string;
  workSiteAddress: string;
  workSiteFullAddress: string;
  workSiteComposedAddress: string;
  workSitePostalCode: string;
  workSiteLocality: string;
  isDraft: number;
  haveUnreadMessages: boolean;
  haveUnreadDocumentDelivered: boolean;
  haveDocumentsCustomers: boolean;
  globalAffairStatus: string;
  isWaitingValidation: boolean;
  affairProducts: AffairProduct[];
  updatedAtFormatted: string;
  affairsDocumentsDelivered?: Document[];
  unitNumber: string;
}

export interface Document {
  id: number;
  productName: string;
  path: string;
  createdAt: Date;
  documentDeliveredName: string;
}

@Component({
  selector: 'app-affaires-list',
    imports: [
        NavbarComponent,
        MatTableModule,
        MatPaginatorModule,
        MatButtonModule,
        MatCardModule,
        MatInputModule,
        MatFormFieldModule,
        HttpClientModule,
        FormsModule,
        MatProgressSpinner,
        NgIf,
        NgForOf,
        MatIcon
    ],
  providers: [AffairesService, DocumentsService, { provide: MatPaginatorIntl, useValue: getFrenchPaginatorIntl() }],
  templateUrl: './affaires-list.component.html',
  styleUrl: './affaires-list.component.css'
})
export class AffairesListComponent implements AfterViewInit, OnInit {
  displayedColumns: string[] = ['plus', 'id', 'name', 'address', 'latestDocument', 'navigate'];
  dataSource = new MatTableDataSource<Affair>([]);

  public currentLotID: string = '';

  public affairesCount: number = 0;

  public currentAffaireProducts: AffairProduct[] = [];
  private currentAffaires: Affair[] = [];
  private filtredAffaires: Affair[] = [];
  public currentAffaireID: number = 0;

  public isLoading: boolean = false;

  public searchString: string = '';

  public filterOpened: boolean = false;

  private queryParams: AffairQueryParams = {
    selectedAgencies:  '[]',
    selectedProducts: '[]',
    selectedProductsStatuses: '[]',
    search: '',
    size: 50,
    page: 1
  };

  constructor(
    private affairesService: AffairesService,
    private snackBar: MatSnackBar,
    private route: ActivatedRoute,
    private http: HttpClient,
    public router: Router,
    private documentsService: DocumentsService,
  ) {}

  @ViewChild(MatPaginator) paginator!: MatPaginator;

  switchFilter(): void {
    this.filterOpened = !this.filterOpened;
  }

  updateSearchString(event: any): void {
    if(this.searchString.length > 2) {
      this.queryParams.search = this.searchString;

      this.searchString = this.searchString.toLowerCase();

      this.filtredAffaires = this.currentAffaires.filter((affaire) => {
        return (
            affaire.mlRef.toLowerCase().includes(this.searchString) ||
            affaire.workSiteFullAddress.toLowerCase().includes(this.searchString) ||
            affaire.workSitePostalCode.toLowerCase().includes(this.searchString) ||
            affaire.finalCustomerLastname.toLowerCase().includes(this.searchString) ||
            affaire.finalCustomerFirstname?.toLowerCase().includes(this.searchString)
        );
      });
      this.dataSource.data = this.filtredAffaires;
    } else {
      this.dataSource.data = this.currentAffaires;
    }
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit() {
    this.currentLotID = this.route.snapshot.params['id'];
    this.fetchAffaires();
  }

  fetchAffaires() {
    this.isLoading = true;

    this.affairesService.getAllFromLot(this.currentLotID).subscribe({
      next: (data) => {
        this.dataSource.data = data;
        this.affairesCount = data.length;

        this.currentAffaires = data;

        console.log(this.currentAffaires);

        if (this.paginator) {
          this.dataSource.paginator = this.paginator;
        }

        this.isLoading = false;
      },
      error: (error) => {
        this.snackBar.open(error.message, 'Fermer', {
          duration: 5000,
        });
        this.isLoading = false;
      }
    });
  }

  setCurrentAffaireProducts(id: number) {

    if(this.currentAffaireID === id) {
      this.currentAffaireProducts = [];
      this.currentAffaireID = 0;
      return;
    }

    let currentAffair = this.currentAffaires.filter((item) => {
      return item.id == id;
    })

    this.currentAffaireID = id;

    this.currentAffaireProducts = currentAffair[0]?.affairProducts;
  }

  // TODO: add this method inside a service

  downloadLatestDocument(documents: Document[]): void {
    this.documentsService.downloadLatestDocument(documents);
  }

  navigateToAffair(ref: string) {
    this.router.navigate(["affaire", ref]);
  }
}
